import React from 'react'; 

import classes from './TooltipError.scss';

const tooltipError = (props) => {

    const { showTooltip, ...rest } = props;

    let tooltipClasses = [classes.Tooltip];

    if(props.type === 'loginError') {
        tooltipClasses.push(classes.TooltipError);
    }

    if(props.showTooltip && props.type === 'loginError') {
        tooltipClasses.push(classes.ShowTooltipError);
    }

    return (
        <span {...rest} className={tooltipClasses.join(' ')}>{props.children}</span>
    );
}

export default tooltipError;


// WEBPACK FOOTER //
// ./src/components/UI/TooltipError/TooltipError.js